<template>
    <div v-if="currentLanguage=='fr'" class="text-center d-flex justify-content-center p-0 m-0 w-100">
        <AboutUs_FR/>
    </div>
    <div v-else-if="currentLanguage=='de'" class="text-center d-flex justify-content-center p-0 m-0 w-100">
        <AboutUs_DE/>
    </div>
    <div v-else-if="currentLanguage=='es'" class="text-center d-flex justify-content-center p-0 m-0 w-100">
        <AboutUs_ES/>
    </div>
    <div v-else-if="currentLanguage=='it'" class="text-center d-flex justify-content-center p-0 m-0 w-100">
        <AboutUs_IT/>
    </div>
    <div v-else-if="currentLanguage=='nl'" class="text-center d-flex justify-content-center p-0 m-0 w-100">
        <AboutUs_NL/>
    </div>
    <div v-else-if="currentLanguage=='pt'" class="text-center d-flex justify-content-center p-0 m-0 w-100">
        <AboutUs_PT/>
    </div>                                      
    <div v-else class="text-center d-flex justify-content-center p-0 m-0 w-100">
        <AboutUs_EN/>
    </div>
</template>

<script>
    import AboutUs_EN from './AboutUs/AboutUs_EN.vue';
    import AboutUs_FR from './AboutUs/AboutUs_FR.vue';
    import AboutUs_DE from './AboutUs/AboutUs_DE.vue';
    import AboutUs_ES from './AboutUs/AboutUs_ES.vue';
    import AboutUs_IT from './AboutUs/AboutUs_IT.vue';
    import AboutUs_NL from './AboutUs/AboutUs_NL.vue';
    import AboutUs_PT from './AboutUs/AboutUs_PT.vue';

    export default {
        name: "AboutUs",
        components: {
            AboutUs_EN,
            AboutUs_FR,
            AboutUs_DE,
            AboutUs_ES,
            AboutUs_IT,
            AboutUs_NL,
            AboutUs_PT,
        },        
        computed: {
            currentLanguage() {
                return this.$store.state.language
            },
        }
    }
</script>

<style>
</style>